import React, { memo, ReactNode, useMemo } from "react";
import { default as ArrowBack } from "@swiggy-private/dls-web-icons/dist/web/generic/arrowBack/20";

// dls
import { GenericIcon } from "@swiggy-private/dls-web-icons/dist/GenericIconWeb";

// style
import { HeaderContentWrapper, IconContainer } from "../Header.style";
import { isEmpty } from "@swiggy-private/js-utils";

const HeaderContent = ({
    onBackButtonClick,
    children,
    restaurantName,
    isCartError,
    isEmptyCart,
    isRtbXpEnabled,
    isAnimationInProgress,
}: {
    onBackButtonClick: VoidFunction;
    children: ReactNode;
    restaurantName?: string;
    isCartError?: boolean;
    isEmptyCart?: boolean;
    isRtbXpEnabled?: boolean;
    isAnimationInProgress?: boolean;
}) => {
    // Determine the stroke and fill color based on the theme and environment
    const isStaging = typeof window !== "undefined" && window.__ENVIRONMENT__ === "staging";
    const isStaging2 = typeof window !== "undefined" && window.__ENVIRONMENT__ === "staging-2";
    const iconColor = useMemo(() => {
        if (isRtbXpEnabled) {
            return "text_Highest_Emphasis";
        }
        if (isEmpty(restaurantName)) {
            return "text_Med_Emphasis";
        }
        if (isStaging) {
            return "rain";
        } else if (isStaging2) {
            return "warning";
        } else {
            return "background_Primary";
        }
    }, [isStaging, isStaging2, isRtbXpEnabled, restaurantName]);

    return (
        <HeaderContentWrapper
            $isRtbXpEnabled={isRtbXpEnabled}
            restaurantName={restaurantName}
            isCartError={isCartError}
            isEmptyCart={isEmptyCart}
            $isAnimationInProgress={isAnimationInProgress}
        >
            <IconContainer $isAnimationInProgress={isAnimationInProgress}>
                <GenericIcon
                    Icon={ArrowBack}
                    onClick={onBackButtonClick}
                    strokeColor={iconColor}
                    fillColor={iconColor}
                />
            </IconContainer>
            <div>{children}</div>
        </HeaderContentWrapper>
    );
};

export default memo(HeaderContent);
